export default __webpack_public_path__ + "static/media/Feature1.7911a508.png";